import { PropsWithChildren } from "react";
import classNames from "classnames";

interface PlaceholderProps extends PropsWithChildren {
  className?: string;
  "data-testid"?: string;
}

export const Placeholder = ({ className, children, "data-testid": dataTestId }: PlaceholderProps) => {
  return (
    <div
      className={classNames(
        "bg-neutral-100",
        "border-neutral-400",
        "border",
        "rounded-sm",
        "flex",
        "items-center",
        "justify-center",
        "border-dashed",
        className
      )}
      data-testid={dataTestId || "letter-placeholder"}
    >
      {children}
    </div>
  );
};
